import {bindable, customElement, inject} from 'aurelia-framework';
import {I18N} from 'aurelia-i18n';
import {UserService} from '../../services/user-service';
import {find, isArray, map, remove, trim} from 'lodash';
import keyCode from 'keycode';
import {HttpResponseMessage} from "aurelia-http-client";

@inject(I18N, UserService)
@customElement('search-communication-users')
export class SearchCommunicationUsers {
  // static inject = [I18N];

  @bindable inviteLabel = 'search-communication-users.invite-btn';

  selectedContacts: any[] = [];
  availableContacts = [
    {
      'nickaName': '1111',
      'id': 16,
      'fullName': 'John TSDFGH'
    },
    {
      'nickaName': '325235',
      'id': 1262,
      'fullName': 'Bill GSSDGGSD'
    },
    {
      'nickaName': '23532532',
      'id': 12362,
      'fullName': 'Bill111 WGWEEWGWEGWEG'
    },
    {
      'nickaName': 'jtravolta',
      'id': 6,
      'fullName': 'John Travolta'
    },
    {
      'nickaName': 'bmurray',
      'id': 126,
      'fullName': 'Bill Murray'
    },
  ];
  highlightedUser: any = {};
  searchMask: string = '';
  __searchUsersRequest: Promise<HttpResponseMessage> & { cancel?: () => void }

  constructor(private i18n: I18N, private __userService: UserService) {
    // console.log(this.i18n.tr('add_members_select'));
  }

  inviteUsers() {
    if (this.selectedContacts.length > 0) {
      // TODO invite contacts
      let contacts = map(this.selectedContacts, 'nickName');
    }
  }

  onRemoveSelected(user) {
    user.isSelected = false;
    this.selectedContacts = remove(this.selectedContacts, u => u.id != user.id);
  }

  onAddSelected(user) {
    if (user && this.selectedContacts.length < 3 && !user.isSelected) {
      user.isSelected = true;
      this.selectedContacts.push(user);
    }
  }

  onMouseOver(user) {
    this.highlightedUser = user;
  }

  onMouseOut(user) {
    if (user.id && user.isHighlighted) {
      this.highlightedUser = {};
      user.isHighlighted = false;
    }
  }

  filledSelectedContacts() {
    return this.selectedContacts.length === 3;
  }

  // @computedFrom()
  // get clazz() {
  //     return
  // }

  highlightUser(newValue, oldValue) {
    console.error('highlightUser');
    if (oldValue) {
      oldValue.isHighlighted = false;
    }
    if (newValue) {
      newValue.isHighlighted = true;
    }
  }

  nextPortion() {
    // TODO nextPortion
  }

  /**
   * @private
   */
  __clearSearch() {
    console.error('__clearSearch');
    if (this.highlightedUser.isHighlighted) {
      this.highlightedUser = {};
      this.highlightedUser.isHighlighted = false;
    }

    this.availableContacts = [];
  }


  __oldMask = '';

  /**
   * @private
   */
  __searchUsers() {
    console.error('__searchUsers');
    let mask = trim(this.searchMask);
    let oldMask = this.__oldMask;
    this.__oldMask = mask;

    if (oldMask === mask) return;

    if (mask.length < 3) {
      this.__clearSearch();
      return;
    }

    this.__cancelSearchRequest();

    let {response, request} = this.__userService.searchUsersByMask(mask, {pageSize: 10, pageNum: 0});
    response.then(data => {
      if (isArray(data.individuals))        {this.availableContacts = data.individuals;}      else        {this.availableContacts = [];}
    }).catch(response => {

    });

    this.__searchUsersRequest = request;
  }

  /**
   * @private
   */
  __cancelSearchRequest() {
    if (this.__searchUsersRequest) {
      this.__searchUsersRequest.cancel();
      this.__searchUsersRequest = null;
    }
  }

  /**
   * @private
   */
  __onBackspace() {
    console.error('__onBackspace');
    if (this.searchMask.length >= 3 && this.highlightedUser.isHighlighted) {
      let user = find(this.availableContacts, {'id': this.highlightedUser.id});
      this.highlightedUser = user ? user : {};
    }
    this.__searchUsers();
  }

  /**
   * @private
   */
  __appendLast() {
    if (this.availableContacts.length === 1) {
      this.onAddSelected(this.availableContacts[0]);
    }
  }

  onKeyUp(e) {
    let code = keyCode(e);
    console.error('onKeyUp');

    if (code === 'enter') {
      this.__appendLast();
    } else if (code === 'backspace') {
      this.__onBackspace();
    } else {
      this.__searchUsers();
    }
  }

}


// @bindingBehavior('search')
// export class SearchBehavior {
//
//     bind(binding, scope) {
//         // debugger;
//
//         binding['search-callSource'] = binding['callSource'];
//
//         let oldValue = '';
//
//         binding['callSource'] = (...rest) => {
//             debugger;
//
//             oldValue = binding.target.value;
//             binding['search-callSource'](...rest);
//         };
//     }
//
//     unbind(binding, scope) {
//         debugger;
//     }
// }
